import { useEffect, useState } from 'react';

// Pages hidden from visitors (Admin → Toutes les pages du site), shared by menus and the page gate.
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;
let regionsCache = null;
const listeners = new Set();

const load = () => {
  if (!cache) {
    cache = fetch(`${API}/site-visibility`).then(r => r.json()).then(d => d.hidden_paths || []).catch(() => []);
  }
  return cache;
};

export const refreshSiteVisibility = () => {
  cache = null;
  regionsCache = null;
  load().then(paths => listeners.forEach(fn => fn(paths)));
};

export const pathIsHidden = (hiddenPaths, pathname) => {
  const path = (pathname || '').split('?')[0].replace(/\/+$/, '') || '/';
  return hiddenPaths.some(h => path === h || path.startsWith(`${h}/`));
};

export const useSiteVisibility = () => {
  const [hidden, setHidden] = useState([]);
  useEffect(() => {
    let alive = true;
    load().then(p => alive && setHidden(p));
    listeners.add(setHidden);
    return () => { alive = false; listeners.delete(setHidden); };
  }, []);
  return { hiddenPaths: hidden, isHidden: (path) => pathIsHidden(hidden, path) };
};

// Visible regions for the menus (hidden regions are filtered by the API).
export const useMenuRegions = (fallback) => {
  const [regions, setRegions] = useState(fallback);
  useEffect(() => {
    if (!regionsCache) {
      regionsCache = fetch(`${API}/regions`).then(r => r.json())
        .then(list => list.map(r => ({ label: r.name, slug: r.slug })))
        .catch(() => null);
    }
    let alive = true;
    regionsCache.then(list => alive && list && setRegions(list));
    return () => { alive = false; };
  }, []);
  return regions;
};
